// src/components/SendMessageModal.js
import React, { useRef } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@mui/material';
import SendMessage from './SendMessage';

export default function SendMessageModal({
                                             open,
                                             onClose,
                                             affiliate,
                                             affiliateEmail,
                                             preSelectedUsers = [],
                                             preSelectedGuests = [],
                                             initialSubject = '',
                                             initialBody = ''
                                         }) {
    const sendHandlerRef = useRef(null);

    const handleSendClick = (handler) => {
        sendHandlerRef.current = handler;
    };

    const handleSend = (e) => {
        if (sendHandlerRef.current && sendHandlerRef.current.handleSend) {
            sendHandlerRef.current.handleSend(e);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            fullScreen={window.innerWidth < 600}
            slotProps={{ root: { sx: { zIndex: 2200 } } }}
        >
            <DialogTitle sx={{
                textAlign: "center",
                fontSize: "1.5rem",
                fontWeight: "bold"
            }}>
                Send Message
            </DialogTitle>
            <DialogContent>
                <SendMessage
                    affiliate={affiliate}
                    affiliateEmail={affiliateEmail}
                    preSelectedUsers={preSelectedUsers}
                    preSelectedGuests={preSelectedGuests}
                    initialSubject={initialSubject}
                    initialBody={initialBody}
                    onMessageSent={onClose}
                    onSendClick={handleSendClick}
                />
            </DialogContent>
            <DialogActions sx={{ justifyContent: "space-between", p: 2 }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSend}
                >
                    Send
                </Button>
                <Button
                    onClick={onClose}
                    variant="outlined"
                    sx={{
                        backgroundColor: '#e0e0e0',
                        color: '#333',
                        border: 'none',
                        '&:hover': {
                            backgroundColor: '#d0d0d0',
                            border: 'none'
                        }
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}